export default "__VITE_ASSET__d77bb20a__"